/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Components, Theme } from "@mui/material/styles";

export const muiButtonStyle = (): Components<Theme>["MuiButton"] => ({
  styleOverrides: {
    root: {
      padding: "1rem 1.5rem",
      fontWeight: 500,
      variants: [
        {
          props: { size: "small" },
          style: {
            padding: "0.75rem 1rem",
            fontSize: "1rem",
            "&, &&:hover, &&:focus, &&:focus-visible": {
              boxShadow: "none",
            },
          },
        },
        {
          props: { variant: "contained", disableElevation: false },
          style: () => {
            const boxShadow = "0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 2px 4px -1px rgba(0, 0, 0, 0.20)";

            return {
              boxShadow,
              "&:hover, &:focus": {
                boxShadow,
              },
            };
          },
        },
        {
          props: { variant: "outlined" },
          style: {
            borderWidth: "0.125rem",
          },
        },
        {
          props: { variant: "outlined", size: "medium" },
          style: {
            padding: "0.875rem 1.375rem",
          },
        },
        {
          props: { variant: "outlined", size: "small" },
          style: {
            padding: "0.625rem 0.875rem",
          },
        },
      ],
    },
  },
});
